import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { PropsWithChildren } from 'react';
import { createComposableProvider } from 'shared/lib';
import { theme } from 'shared/ui';

export const ThemeProvider = ({ children }: PropsWithChildren) => (
	<MantineProvider theme={theme}>
		<Notifications />
		{children}
	</MantineProvider>
);

export const withTheme = createComposableProvider(ThemeProvider);
